export const logoutUser = () => {
  localStorage.removeItem("profile");
  window.location.reload();
};

let memo = null;

export const getUserDetails = () => {
  if (memo) {
    return memo;
  }
  memo = JSON.parse(localStorage.getItem("profile"));
  return memo;
};
